import { DistrictDatasource } from "@beneficiary/data/datasource/district.datasource";
import { BeneficiaryDistrictError } from "@beneficiary/domain/errors/beneficiary.error";
import { DistrictMapperError } from "@beneficiary/domain/errors/district/district-mapper.error";
import { District } from "@beneficiary/domain/models/district.model";
import { Pagination } from "@core/domain/models/pagination";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class DistrictsRepository {
    constructor(
        @inject(DistrictDatasource)
        private readonly districtDatasource: DistrictDatasource,
    ) { }

    async getAll(
        pagination: Pagination,
    ): Promise<Either<BeneficiaryDistrictError | DistrictMapperError, District[]>> {
        const districtResult =
            await this.districtDatasource.fetchAll(pagination);

        return districtResult
            .map((district) => district);
    }
}
